import { locale } from './constants'

const getErrorPage = (message: string): string => {
  if (message.includes('passwordless')) return 'passwordless'
  if (message.includes('reset_password')) return 'reset password'
  return 'generic'
}

export default (message: string): Record<string, unknown> => {
  const page = getErrorPage(message)
  return {
    page: {
      locale,
      pageInfo: {
        breadCrumb: [
          { value: page, clickable: 1 },
          {
            value: 'error page',
            clickable: 1,
          },
        ],
        pageName: `jl:${page}:error page`,
        pageType: 'account',
        site: window.location.host,
      },
    },
    error: {
      type: 'sso:system',
      message,
    },
  }
}
